<template>
    <div class="common-sms-verification-block">
        <div
            class="common-sms-verification-block__container"
            v-if="isCodeCheckInitiated"
        >
            <slot />
        </div>
        <div
            class="common-sms-verification-block__container"
            v-else
        >
            <div
                class="common-sms-verification-block__container-title"
                v-text="'Код будет выслан на номер:'"
            />
            <div
                class="common-sms-verification-block__container-phone"
                v-text="phone"
            />
            <div class="common-sms-verification-block__container-button">
                <ui-button v-on:click="requestCode">
                    Получить СМС-код
                </ui-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'common-sms-verification-block',
    props: {
        phone: String,
    },
    data: () => ({
        isCodeCheckInitiated: false,
    }),
    methods: {
        requestCode() {
            this.isCodeCheckInitiated = true;
        },
    },
};
</script>

<style lang="less">
@import '~theme';

.common-sms-verification-block__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    max-width: 720px;
    margin: 0 auto;

    text-align: center;

    &-title {
        .typography-body();

        margin-bottom: 8px;
    }

    &-phone {
        .typography-heading();

        margin-bottom: 24px;
    }
}
</style>
